// extracted by mini-css-extract-plugin
export default {"error-container":"ErrorBoundary_error-container__0UtrK","error-text-container":"ErrorBoundary_error-text-container__Ju7g0"};